import { DefaultError, useMutation } from "@tanstack/react-query";
import { bulkUpdateFaqsList } from "../api/bulkUpdateFaqsList";
import {
  setFaqsListByFaqGroupQueryData,
  invalidateFaqsListByFaqGroupQuery,
} from "../queries/useFaqsListByFaqGroupQuery";
import { FaqData } from "../types";

type Params = {
  faqsList: FaqData[];
};

export const useReorderFaqsListMutation = (faqGroupId: string) => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async (variables) => {
      const dataToUpdate = variables.faqsList.reduce((acc, faqData) => {
        return {
          ...acc,
          [faqData.id]: { order: faqData.order },
        };
      }, {});

      setFaqsListByFaqGroupQueryData(faqGroupId, variables.faqsList);

      await bulkUpdateFaqsList(faqGroupId, dataToUpdate);
    },
    onSettled: (data, _) => {
      invalidateFaqsListByFaqGroupQuery(faqGroupId);
    },
  });
};
